export interface FirebaseTimeStamp {
  nanoseconds: number;
  seconds: number;
}
